export default String.raw`
.reportContent {
    &-popup {
        width: fit-content;
        padding: 0 16px 32px;

        .inputs-container-js {
            height: 500px;
            overflow: auto;
            padding-right: 24px;
        }
    }
}

@media screen and (max-width: 500px){
    .text-overflow {
        width: 320px;
    }
}
@media screen and (max-width: 450px){
    .text-overflow {
        width: 300px;
    }
}
@media screen and (max-width: 425px){
    .text-overflow {
        width: 280px;
    }
}
@media screen and (max-width: 405px){
    .text-overflow {
        width: 240px;
    }
}
`